//停车管理
export default [{
        path: '/vipCar',
        component: () =>
            import ('../pages/plateManage/vipCar.vue'),
        name: 'vipCar',
        title: "内部车管理",
        meta: {
            title: "内部车管理"
        }
    },
    {
        path: '/bookingCar',
        component: () =>
            import ('../pages/plateManage/bookingCar.vue'),
        name: 'bookingCar',
        title: "预约车管理",
        meta: {
            title: "预约车管理"
        }
    },
    {
        path: '/plateOrder',
        component: () =>
            import ('../pages/plateManage/plateOrder.vue'),
        name: 'plateOrder',
        title: "停车缴费订单",
        meta: {
            title: "停车缴费订单"
        }
    },
    {
        path: '/plateNoManage',
        component: () =>
            import ('../pages/plateManage/plateNoManage.vue'),
        name: 'plateNoManage',
        title: "车牌号管理",
        meta: {
            title: "车牌号管理"
        }
    },
    {
        path: '/rightsDefinition',
        component: () =>
            import ('../pages/plateManage/rightsDefinition.vue'),
        name: 'rightsDefinition',
        title: "停车权益配置",
        meta: {
            title: "停车权益配置"
        }
    }


];